import { useState } from 'react';
import AddressBody from '../../../../../features/Address/AddressBody';
import LibModal from '../../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import useApi from '../../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { EditIcon } from '../../../../../utils/SVGIcon';
import { useAgencyInfo } from '../../../AgencyInfoProvider';
import AddressSameAsRadio from './AddressSameAsRadio';

// -- Address Edit Button
function AddressEditModal({ data, title }) {
    const { post } = useApi();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { handleReload, agencyInfoData } = useAgencyInfo();
    const { setMessage } = useTemplate();
    // -- Edit Address Modal
    const [showEditAddressModal, setShowEditAddressModal] = useState({
        show: false,
        data: {}
    });
    // -- initial form data
    const [formData, setFormData] = useState({
        addressType: title?.toString()?.toLowerCase(),
        userId: agencyInfoData?.id,
        ...data,
        Status: data.status
    });
    // -- Handle On Change to set form data
    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };
    const handleSameAs = (e, type) => {
        const addressType = title?.toString()?.toLowerCase();
        setFormData({
            ...formData,
            ...agencyInfoData?.addresses?.[type],
            addressType
        });
    };
    // -- Save Edit Address
    const handleSaveEditAddress = (e) => {
        e.preventDefault();
        setLoading(true);
        post('/api/customer-addresses', formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setShowEditAddressModal({ show: false, data: {} });
                setMessage({ type: 'success', text: message });
                handleReload();
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString() });
            })
            .finally(() => {
                setLoading(false);
            });
    };
    FocusControl(isError, setIsError, formData);

    return (
        <>
            {/* Edit Address Button */}
            <button
                type="button"
                onClick={() =>
                    setShowEditAddressModal({ show: true, data }) +
                    setFormData({ ...formData, ...data })
                }
                className="w-7 h-7 bg-warning/10 hover:bg-warning text-warning hover:text-white-100  p-1 rounded-md transition-colors"
            >
                <EditIcon />
            </button>
            {/* Edit Address Modal */}
            {showEditAddressModal.show && (
                <LibModal
                    title="Edit Address"
                    setOpen={() => setShowEditAddressModal({ show: false, data: {} })}
                    className="sm:w-[570px]"
                >
                    <form onSubmit={handleSaveEditAddress}>
                        <div className="flex justify-start items-center gap-3 pb-5">
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'administrative'}
                                type="administrative"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'billing'}
                                type="billing"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                            <AddressSameAsRadio
                                isShow={data?.addressType?.toString() !== 'technical'}
                                type="technical"
                                onClick={(e, type) => handleSameAs(e, type)}
                            />
                        </div>
                        <AddressBody formData={formData} onChange={handleOnChange} editMode />

                        <div className="flex flex-row justify-end items-center gap-4 my-4">
                            <ButtonCancel
                                title="Cancel"
                                onClick={() => setShowEditAddressModal({ show: false, data: {} })}
                            />
                            <ButtonPrimary btnType="submit" title="Save" loading={loading} />
                        </div>
                    </form>
                </LibModal>
            )}
        </>
    );
}

export default AddressEditModal;
